module.exports = __webpack_public_path__ + "static/2front-about-people-more-544c2fe03a705129cc9949b8f03c0acd.png";